import { Stack, StackProps } from "@mui/material";
import PrintContainerHeader from "./header";

export default function PrintContainer({
    children,
    ...props
}: StackProps) {
    return <Stack {...props} gap={3} padding={3}>
        {children}
    </Stack>
}

PrintContainer.Header = PrintContainerHeader;